const ACTIONS = {
    GET_DATA_SUCCESS: 'GET_DATA_SUCCESS',
    GET_DATA_ERROR: 'GET_DATA_ERROR',
    GET_PLAYER_CONDITION_PITCHER_SUCCESS: 'GET_PLAYER_CONDITION_PITCHER_SUCCESS',
    GET_PLAYER_CONDITION_PITCHER_ERROR: 'GET_PLAYER_CONDITION_PITCHER_ERROR'
};

const headerPitcherTableCommon = ["被打率", "打数", "被安打", "被本塁打", "奪三振", "与四球", "与死球",]

const titlePitcherTable1 = {
    dot: false,
    text: '対セ・リーグ チーム別成績',
}
const headerPitcherTable1 = ["対戦", "防御率", "登板", "完投", "完封", "無四球", "勝利", "敗戦", "ホールド", "HP", "セーブ", "勝率",
    "投球回", "打者", "被安打", "被本塁打", "奪三振", "奪三振率", "与四球", "与死球", "暴投", "ボーク", "失点", "自責点",]
const dataPitcherTable1 = [
    {
        item: [
            { img: '/img/team/Swallows.png' },
            { text: 26 },
            { text: 26 },
            { text: 26 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
        ]
    },
    {
        item: [
            { img: '/img/team/Carp.png' },
            { text: 26 },
            { text: 26 },
            { text: 26 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
        ]
    },
    {
        item: [
            { img: '/img/team/DeNA.png' },
            { text: 26 },
            { text: 26 },
            { text: 26 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
        ]
    },
    {
        item: [
            { img: '/img/team/Dragons.png' },
            { text: 26 },
            { text: 26 },
            { text: 26 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
        ]
    },
    {
        item: [
            { img: '/img/team/Tigers.png' },
            { text: 26 },
            { text: 26 },
            { text: 26 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
        ]
    },
]

const titlePitcherTable2 = {
    dot: false,
    text: '対パ・リーグ チーム別成績',
}
const headerPitcherTable2 = ["対戦", "防御率", "登板", "完投", "完封", "無四球", "勝利", "敗戦", "ホールド", "HP", "セーブ", "勝率",
    "投球回", "打者", "被安打", "被本塁打", "奪三振", "奪三振率", "与四球", "与死球", "暴投", "ボーク", "失点", "自責点",]
const dataPitcherTable2 = [
    {
        item: [
            { img: '/img/team/Lions.png' },
            { text: 26 },
            { text: 26 },
            { text: 26 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
        ]
    },
    {
        item: [
            { img: '/img/team/Hawks.png' },
            { text: 26 },
            { text: 26 },
            { text: 26 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
        ]
    },
    {
        item: [
            { img: '/img/team/Fighters.png' },
            { text: 26 },
            { text: 26 },
            { text: 26 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
        ]
    },
    {
        item: [
            { img: '/img/team/Bufalloes.png' },
            { text: 26 },
            { text: 26 },
            { text: 26 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
        ]
    },
    {
        item: [
            { img: '/img/team/Marines.png' },
            { text: 26 },
            { text: 26 },
            { text: 26 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
        ]
    },
]

const titlePitcherTable3 = {
    dot: false,
    text: '月別成績',
}
const headerPitcherTable3 = ["月", "防御率", "登板", "完投", "完封", "無四球", "勝利", "敗戦", "ホールド", "HP", "セーブ", "勝率",
    "投球回", "打者", "被安打", "被本塁打", "奪三振", "奪三振率", "与四球", "与死球", "暴投", "ボーク", "失点", "自責点",]
const dataPitcherTable3 = [
    {
        item: [
            { text: '3月' },
            { text: 26 },
            { text: 26 },
            { text: 26 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
        ]
    },
    {
        item: [
            { text: '4月' },
            { text: 26 },
            { text: 26 },
            { text: 26 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
        ]
    },
    {
        item: [
            { text: '5月' },
            { text: 26 },
            { text: 26 },
            { text: 26 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
        ]
    },
    {
        item: [
            { text: '6月' },
            { text: 26 },
            { text: 26 },
            { text: 26 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
        ]
    },
    {
        item: [
            { text: '7月' },
            { text: 26 },
            { text: 26 },
            { text: 26 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
        ]
    },
]

const titlePitcherTable4 = {
    dot: false,
    text: '左右打者別成績',
}
const headerPitcherTable4 = ["打者", ...headerPitcherTableCommon]
const dataPitcherTable4 = [
    {
        item: [
            { text: '右打者' },
            { text: '.234' },
            { text: 26 },
            { text: 26 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
        ]
    },
    {
        item: [
            { text: '右打者' },
            { text: '.234' },
            { text: 26 },
            { text: 26 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
        ]
    },
]

const titlePitcherTable5 = {
    dot: false,
    text: '球場別成績',
}
const headerPitcherTable5 = ["球場", "防御率", "登板", "完投", "完封", "無四球", "勝利", "敗戦", "ホールド", "HP", "セーブ", "勝率",
    "投球回", "打者", "被安打", "被本塁打", "奪三振", "奪三振率", "与四球", "与死球", "暴投", "ボーク", "失点", "自責点",]
const dataPitcherTable5 = [
    {
        item: [
            { text: '東京ドーム' },
            { text: 26 },
            { text: 26 },
            { text: 26 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
        ]
    },
    {
        item: [
            { text: '神宮' },
            { text: 26 },
            { text: 26 },
            { text: 26 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
        ]
    },
    {
        item: [
            { text: '横浜' },
            { text: 26 },
            { text: 26 },
            { text: 26 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
        ]
    },
    {
        item: [
            { text: 'ナゴヤドーム' },
            { text: 26 },
            { text: 26 },
            { text: 26 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
        ]
    },
    {
        item: [
            { text: '甲子園' },
            { text: 26 },
            { text: 26 },
            { text: 26 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
        ]
    },
    {
        item: [
            { text: 'メットライフ' },
            { text: 26 },
            { text: 26 },
            { text: 26 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
        ]
    },
    {
        item: [
            { text: '京セラD大阪' },
            { text: 26 },
            { text: 26 },
            { text: 26 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
        ]
    },
    {
        item: [
            { text: '鹿児島' },
            { text: 26 },
            { text: 26 },
            { text: 26 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
        ]
    },
    {
        item: [
            { text: '熊本' },
            { text: 26 },
            { text: 26 },
            { text: 26 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
        ]
    },
    {
        item: [
            { text: '札幌ドーム' },
            { text: 26 },
            { text: 26 },
            { text: 26 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
        ]
    },
    {
        item: [
            { text: '楽天生命パーク' },
            { text: 26 },
            { text: 26 },
            { text: 26 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
        ]
    },
    {
        item: [
            { text: 'マツダスタジアム' },
            { text: 26 },
            { text: 26 },
            { text: 26 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
        ]
    },
    {
        item: [
            { text: '三次' },
            { text: 26 },
            { text: 26 },
            { text: 26 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
            { text: 0 },
        ]
    },
];

const titlePitcherTable6 = {
    dot: false,
    text: 'カウント別成績',
};
const headerPitcherTable6 = ["カウント", ...headerPitcherTableCommon]

const titlePitcherTable7 = {
    dot: false,
    text: '塁状況別成績',
}
const headerPitcherTable7 = ["ランナー", ...headerPitcherTableCommon]

const titlePitcherTable8 = {
    dot: false,
    text: 'イニング別成績',
}
const headerPitcherTable8 = ["イニング", ...headerPitcherTableCommon]

const titlePitcherTable9 = {
    dot: false,
    text: 'イニング先頭打者成績',
}
const headerPitcherTable9 = ["イニング先頭", ...headerPitcherTableCommon]

export default (state = {
    titlePitcherTable1, headerPitcherTable1, dataPitcherTable1,
    titlePitcherTable2, headerPitcherTable2, dataPitcherTable2,
    titlePitcherTable3, headerPitcherTable3, dataPitcherTable3,
    titlePitcherTable4, headerPitcherTable4, dataPitcherTable4,
    titlePitcherTable5, headerPitcherTable5, dataPitcherTable5,
    titlePitcherTable6, headerPitcherTable6,
    titlePitcherTable7, headerPitcherTable7,
    titlePitcherTable8, headerPitcherTable8,
    titlePitcherTable9, headerPitcherTable9,
}, action) => {
    switch (action.type) {
        case ACTIONS.GET_DATA_SUCCESS:
            return {
                ...state,
                status: action.type,
                response: action.data.data,
            };
        case ACTIONS.GET_PLAYER_CONDITION_PITCHER_SUCCESS:
            return {
                ...state,
                status: action.type,
                response: action.data,
            };
        case ACTIONS.GET_DATA_ERROR:
        case ACTIONS.GET_PLAYER_CONDITION_PITCHER_ERROR:
            return {
                ...state,
                status: action.type,
                response: action.err,
            }
        default:
            return state;
    }
};